var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Calculator from '@/class/Calculator';
import { ALERT_MSG, LS_CART_KEY } from '@shared/data';
import renderCartTemplate from '@/react';
import LocalCart from '@/class/LocalCart';
(function () {
    window.$ = jQuery;
    function onLoadWindowHandle() {
        const url = new URL(window.location.href);
        const param = 'afterSending';
        if (!url.searchParams.has(param))
            return;
        alert(ALERT_MSG.SUCCESS);
        url.searchParams.delete(param);
        window.history.pushState(null, '', url);
    }
    function clearCartAndReload() {
        var _a;
        localStorage.setItem(LS_CART_KEY, '[]');
        window.dispatchEvent(app.dmEvents.update);
        const { popupId } = window.calcData;
        (_a = document.querySelector(`${popupId} .popmake-close`)) === null || _a === void 0 ? void 0 : _a.click();
    }
    function onSubmitFormHandle(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const { isFitter } = window.__ductmaster;
            const form = e.currentTarget;
            const submit = form.querySelector('[type="submit"]');
            const agree = form.querySelector('#agreement:checked');
            if (!isFitter && !agree) {
                alert(ALERT_MSG.AGREEMENT);
                return;
            }
            const enableLoading = () => {
                var _a;
                (_a = form.querySelector('#dm-form-submit')) === null || _a === void 0 ? void 0 : _a.classList.add('form-sending');
                submit.disabled = true;
            };
            const disableLoading = () => {
                var _a;
                (_a = form.querySelector('#dm-form-submit')) === null || _a === void 0 ? void 0 : _a.classList.remove('form-sending');
                submit.disabled = false;
            };
            const initial = {
                BIC: '',
                BILLorder: '',
                checkingAccount: '',
            };
            const orgOrUserSel = 'input[name="radio-org-or-user"]' + (!isFitter ? ':checked' : '');
            const radioDelivery = 'input[name="radio-delivery"]' + (!isFitter ? ':checked' : '');
            const f = [
                { key: 'radioOrgOrUser', sel: orgOrUserSel },
                { key: 'radioDelivery', sel: radioDelivery },
                { key: 'phone', sel: 'input[name="your-phone"]' },
                { key: 'mail', sel: 'input[name="your-mail"]' },
                { key: 'city', sel: 'select[name="your-city"]' },
                { key: 'customer', sel: 'input[name="full-name"]' },
                { key: 'specific', sel: 'input[name="your-specific"]' },
                { key: 'delivery', sel: 'input[name="delivery"]' },
                { key: 'orgName', sel: 'input[name="company"]' },
                { key: 'description', sel: 'input[name="address"]' },
                { key: 'inn', sel: 'input[name="inn"]' },
                { key: 'kpp', sel: 'input[name="kpp"]' },
                { key: 'ogrn', sel: 'input[name="ogrn"]' },
                { key: 'manufacturer', sel: 'select[name="manufacturer"]' },
            ];
            const company = f.reduce((list, { key, sel }) => {
                var _a;
                const value = (_a = jQuery(form).find(sel).val()) !== null && _a !== void 0 ? _a : '';
                list[key] = Array.isArray(value) ? value.join(',') : String(value);
                return list;
            }, initial);
            enableLoading();
            try {
                yield window.mxhpnsSendBill(LocalCart.list, company);
                form.reset();
                if (!window.__ductmaster.themeDebug)
                    clearCartAndReload();
                alert(ALERT_MSG.SUCCESS);
            }
            catch (e) {
                console.error(e);
                alert(ALERT_MSG.WAS_NO_SENT);
            }
            finally {
                disableLoading();
            }
        });
    }
    function setSpecificCustom() {
        const cart = LocalCart.list;
        const specificCustom = document.querySelector('input[name="your-specific"]');
        let specific = '';
        if (!cart.length)
            specific = '(empty)';
        else {
            let totalPrice = 0;
            let totalSquare = 0;
            cart.forEach((item, i) => {
                const isHasSquare = !isNaN(+item.square);
                const itemSquare = isHasSquare && item.type !== 'montage'
                    ? (+item.square * item.count).toFixed(3)
                    : item.square;
                const itemTotal = item.type !== 'montage'
                    ? +item.price * item.count
                    : +item.square * +item.price;
                specific += `№${i + 1}\n`;
                specific += '----\n';
                specific += `Описание: ${item.description}\n`;
                specific += `Площадь (всех элементов): ${itemSquare} м²\n`;
                specific += `Цена одного элемента: ${item.price} ₽\n`;
                specific += `Количество элементов: ${item.count}\n`;
                specific += `Стоимость элементов данного вида: ${itemTotal.toFixed(2)} ₽\n`;
                specific += '\n';
                totalPrice += itemTotal;
                if (isHasSquare && item.type !== 'montage')
                    totalSquare += +itemSquare;
            });
            specific += '===========================================\n';
            specific += '\n';
            specific += `Общая площадь: ${totalSquare.toFixed(3)} м²\n`;
            specific += `Итого цена: ${totalPrice.toFixed(2)} ₽\n`;
        }
        if (specificCustom)
            specificCustom.value = specific;
        else {
            alert(ALERT_MSG.SOME_WENT_WRONG);
            console.warn('#your-specific not found on the page =(');
        }
    }
    function onAddItemCartHandle(e) {
        e.preventDefault();
        app.addCartItem();
    }
    function setCursorPosition(pos, e) {
        if (!e)
            return;
        e.focus();
        if (e.setSelectionRange)
            e.setSelectionRange(pos, pos);
        else if (e.createTextRange) {
            const range = e.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    }
    function phoneMask(e) {
        const input = e.target;
        let matrix = input.placeholder, i = 0, def = matrix.replace(/\D/g, ''), val = input.value.replace(/\D/g, '');
        def.length >= val.length && (val = def);
        matrix = matrix.replace(/[_\d]/g, function (a) {
            return val.charAt(i++) || '_';
        });
        input.value = matrix;
        i = matrix.lastIndexOf(val.substr(-1));
        i < matrix.length && matrix != input.placeholder ? i++ : i = matrix.indexOf('_');
        setCursorPosition(i, input);
    }
    function runPhoneValidation() {
        const input = document.querySelector('#dm_validate_tel');
        if (!input)
            return;
        input === null || input === void 0 ? void 0 : input.addEventListener('input', phoneMask, false);
        input === null || input === void 0 ? void 0 : input.focus();
        setCursorPosition(3, input);
    }
    window.setSpecificCustom = setSpecificCustom;
    const app = new Calculator();
    jQuery(() => {
        app.initialize();
        renderCartTemplate();
        runPhoneValidation();
    });
    const $calculateBtn = document.querySelector(`.${app.rootClass}__calculateBtn`);
    const $formOrder = document.querySelector('#dm-online-order');
    window.addEventListener('load', onLoadWindowHandle);
    $calculateBtn === null || $calculateBtn === void 0 ? void 0 : $calculateBtn.addEventListener('click', onAddItemCartHandle);
    $formOrder === null || $formOrder === void 0 ? void 0 : $formOrder.addEventListener('submit', onSubmitFormHandle);
})();
